import { Component, HostListener, Input, OnInit, Output, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { EFFilterData, EFPOI, EFProduct, EFProductType, EFProductTypeList, EFSupplier } from '../../models/experience.model';
import { EFDataService } from '../../services/ef-data.service';
import { EnvironmentService } from '../../services/environment.service';
import { LocalizationService } from '../../services/localization.service';
import { EfFilterComponent } from '../elements/ef-filter/ef-filter.component';
import { EfMapComponent } from '../elements/ef-map/ef-map.component';
import { AnalyticsService } from '../../services/analytics.service';
import { map, Observable } from 'rxjs';
import { PGUtilities } from '../../utilities/pg-utilities';
import { PgModalService } from '../../pg-ui-elements/pg-modal.service';
import { DataService } from '../../services/data.service';

export type EfMainAppMode = 'web'|'kiosk'|'hybrid'|'iframe'|'iframekiosk';

export class EfMainExternalFilter {
    language?:string
    tags?:string
    type?:string
    category?:string
    product?:string
    groups?:string
    users?:string
    ids?:string
    past?:boolean
}

export class EfMainFragment {
    filter?:Partial<EFFilterData>
    view?:string
    product?:string
}

@Component({
    selector: 'app-ef-main',
    templateUrl: './ef-main.component.html',
    styleUrls: ['./ef-main.component.scss'],
    standalone: false
})
export class EfMainComponent implements OnInit {

    constructor(private efDataService:EFDataService, private dataService:DataService, private localizationService:LocalizationService, private environmentService:EnvironmentService, private analyticsService:AnalyticsService, private pgModalService:PgModalService) {}

    
    @Input() appMode:EfMainAppMode;
    @Input() externalFilter:EfMainExternalFilter;
    @Input() productsList:Array<EFProduct>;
    @Input() setView:string;
    
    @Input() fragment:EfMainFragment;
    @Output() fragmentChange = new EventEmitter<EfMainFragment>();
    
    @Input() hasBack:boolean;
    @Output() goBack = new EventEmitter<void>()
    
    @Input() realmId:string;
    @Input() hasOperatorsBanner:boolean
    @Input() hasShowcase:boolean
    @Input() hasShowcaseWithQR:string
    @Input() showcaseContent:Array<{ type: string, element: string }>;
    
    @Input() mixTypes:boolean;

    @Input() sendEvents:boolean;
    
    showScreensaver = false;

    private _inactivityTimeout = null;

    resetInactivity() {
        this.showScreensaver = false;

        if(this.appMode == 'kiosk' || this.hasShowcase) {
            if(this._inactivityTimeout != null) clearTimeout(this._inactivityTimeout);

            this._inactivityTimeout = setTimeout(() => {
                this._inactivityTimeout = null;
                this.showScreensaver = true;
            }, 1000 * 60 * 5)
        }
    }

    isLoading = false;

    productsData:{ [type:string]: Array<EFProduct> } = null;
    filteredProductsData:Array<EFProduct> = [];
    mapFilteredProductsData:Array<EFProduct> = [];

    filterData = new EFFilterData();

    availableTypes:Array<EFProductType> = [];

    currentSection:string = 'map';

    lockFilter = false;
    lockFilterType = false;
    lockPast = false;

    sectionList = ['map','list','calendar'];
    lockSection = false;

    isPortrait = false;

    @ViewChild('mainContainer') mainContainer:ElementRef

    @HostListener('window:resize', [])
    onResize() {
        this.isPortrait = this.mainContainer.nativeElement.offsetWidth < this.mainContainer.nativeElement.offsetHeight;
    }

    formsUrl:string = null;
    manualUrl:string = null;
    contactEmail:string = null;

    ngOnInit(): void {
        setTimeout(() => {
            this.onResize();
        }, 100)

        if(this.appMode == null) {
            this.appMode = this.environmentService.environment.AppMode;
        }

        this.lockFilter = false;
        this.lockFilterType = false;
        this.lockPast = false;

        this.filterData.type = null;

        this.filterData.tags = null;

        this.filterData.category = {}
        this.filterData.subcategory = {}

        this.filterData.language = {}

        this.productsData = {}

        if(this.appMode == 'web' || this.appMode == 'iframe' || this.appMode == 'iframekiosk') {
            console.log('externalFilter', this.externalFilter)
            console.log('fragment', this.fragment)

            this._handleExternalFilter().then((filtered) => {
                this.availableTypes = []

                let _typesList = (filtered.types == null ? EFProductTypeList.all : filtered.types)

                for(let _type of _typesList) {
                    if(_type != 'utility' || this.environmentService.environment.ExperienceFinderGeoJSON != null) {
                        this.availableTypes.push(_type)
                    }
                }

                this._handleFilterFragment();

                if(!this.mixTypes && this.filterData.type == null) this.filterData.type = this.availableTypes[0];

                this.resetInactivity()
                this.onFilterDataChange();
            });
        }
        else {
            this.resetInactivity()
            this.onFilterDataChange();
        }

        this.formsUrl = this.environmentService.getApplicationURL('Forms')
        this.manualUrl = this.environmentService.getApplicationURL('Viewer') + '/manuals/service'
        this.contactEmail = null;

        let _contactList = this.environmentService.getRealm(this.realmId)?.contacts
        if(_contactList != null) {
            for(let _contact of _contactList) {
                if(_contact.email) {
                    this.contactEmail = _contact.email;
                    break;
                }
            }
        }
    }


    @ViewChild('filterComponent') filterComponent:EfFilterComponent;

    private _checkLoadProducts(type:EFProductType) {
        return new Promise<void>((resolve, reject) => {
            if(this.productsList != null) {
                let _result:Array<EFProduct> = []

                for(let _product of this.productsList) {
                    if(_product.type == type) _result.push(_product);
                }

                this.productsData[type] = _result;
                resolve()
            }
            else {
                this.efDataService.listProducts(null, [type], this.filterData.groups, this.realmId).subscribe((data) => {
                    this.productsData[type] = data[type]
                }, () => {
                }, () => {
                    resolve()
                })
            }
        })
    }

    isLoadingProducts = false;

    presetCategories:{ [type:string]: boolean } = {};

    private async _loadProducts() {
        this.isLoadingProducts = true;

        let _type = this.filterData.type
        let _list:Array<EFProduct> = []

        if(_type != null) {
            await this._checkLoadProducts(_type)
            _list = this.productsData[_type]
        }
        else {
            for(let _item of this.availableTypes) {
                await this._checkLoadProducts(_item)
                _list = _list.concat(this.productsData[_item])
            }
        }

        this.isLoadingProducts = false;

        // qua filtro, perché se ho dei filtri esterni devo tenerne conto quando genero i filtri
        let _filteredProducts = this.efDataService.applyProductsFilter(_list, this.filterData)

        if(_type != null) {
            if(this.filterData.category[_type] != null) { 
                // categorie presettate da filtro esterno
                this.presetCategories[_type] = true;
            }
            else {
                for(let _product of _filteredProducts) {
                    if(_product.category != null && _product.category != '') {
                        let _categoryList = _product.category.split(',')
                        let _subcategoriesList = null;
                        if(_product.subcategory != null && _product.subcategory != '') _subcategoriesList = _product.subcategory.split(',')
    
                        for(let _category of _categoryList) {
                            if(this.filterData.category[_type] == null) {
                                this.filterData.category[_type] = {}
                            }
    
                            this.filterData.category[_type][_category] = false;
    
                            if(_subcategoriesList != null) {
                                for(let _subcategory of _subcategoriesList) {
                                    if(this.filterData.subcategory[_type] == null) {
                                        this.filterData.subcategory[_type] = {}
                                    }
    
                                    if(this.filterData.subcategory[_type][_category] == null) {
                                        this.filterData.subcategory[_type][_category] = {}
                                    }
    
                                    this.filterData.subcategory[_type][_category][_subcategory] = false;
                                }
                            }
                        }
                    }
                }
            }

            let _costsList:Array<number> = [];
            let _productLanguages:Array<string> = [];
    
            for(let _product of _filteredProducts) {
                if(_product.languages != null) {
                    for(let j of _product.languages) {
                        if(_productLanguages.indexOf(j) == -1) {
                            _productLanguages.push(j)
                        }
                    }
                }
    
                if(_product.stars != null) {
                    if(this.filterData.stars[_type] == null) this.filterData.stars[_type] = {}
                    
                    this.filterData.stars[_type][_product.stars] = false;
                }
    
                if(_product.cost_list != null) {                                    
                    for(let _item of _product.cost_list) { // inserisco i range come singoli prezzi
                        _costsList.push(_item)
                    }
                }
            }
    
            _productLanguages.sort();
    
            for(let _language of _productLanguages) {
                if(this.filterData.language[_type] == null) {
                    this.filterData.language[_type] = {}
                }
    
                this.filterData.language[_type][_language] = true;
            }
    
            if(_costsList.length > 0) {
                _costsList.sort((a, b) => {
                    if(a < b) return -1;
                    else if(a > b) return 1;
                    else return 0;
                })
    
                // prendo il più basso e il più alto e divido in 5 segmenti
    
                let _segments = Math.min(5, _costsList.length);
    
                let _min = Math.floor(_costsList[0]);
                let _max = _costsList[_costsList.length - 1];
    
                if(_min != _max) {
                    let _diff = _max - _min;
    
                    let _segmentDiff = Math.ceil(_diff / _segments);
    
                    this.filterData.cost[_type] = [];
    
                    for(let j = 0; j < _segments; j++) {
                        this.filterData.cost[_type].push({
                            from: _min + _segmentDiff * j,
                            to: _min + _segmentDiff * (j + 1),
                            selected: false
                        })
                    }
                }
            }
        }

        if(this.filterComponent != null) {
            this.filterComponent.ngOnInit();
        }

        console.log('_loadProducts ' + _type + ' complete')

        let _missingGeolocation:Array<EFProduct> = [];

        for(let _cProduct of _list) {
            if(_cProduct.geolocation == null) {
                _missingGeolocation.push(_cProduct)
            }
        }
            
        if(_missingGeolocation.length > 0) {
            let _cText = '';
            
            for(let _cProduct of _missingGeolocation) {
                if(_cText != '') _cText += '\n'

                if(_cProduct.base_api != null) {
                    _cText += _cProduct.base_api.replace(/^[^/]*\/\//, '').replace(/\/.*$/, '') + ' '
                }

                _cText += _cProduct.id + ' - ' + _cProduct.title
            }

            console.log('Products missing geolocation: ' + _cText)
        }

        console.log('Available categories', this.filterData.category[_type])
        console.log('Available subcategories', this.filterData.subcategory[_type])
        console.log('Available languages', this.filterData.language[_type])
    }

    private _checkExternalLanguage(lang:string) {
        if(lang != null) {
            return this.localizationService.setLanguage(lang)
        }
        else {
            return new Promise((resolve) => { 
                setTimeout(() => {
                    resolve(null); 
                }, 100)
            })
        }
    }

    private _externalFilterArrayOrSplit(val:string|Array<string>) {
        if(typeof val == 'string') {
            if(val.startsWith('[') && val.endsWith(']')) {
                try {
                    return JSON.parse(val)
                }
                catch(ex) {
                    return PGUtilities.parseCommaSeparatedList(val)
                }
            }
            else {
                return PGUtilities.parseCommaSeparatedList(val)
            }
        }
        else return val;
    }

    private _handleExternalFilter() {
        return new Promise<{ types: Array<EFProductType>, groups: Array<string> }>((resolve) => {    
            if(this.externalFilter == null) {
                resolve({ types: null, groups: null });
            }
            else {
                console.log('External filter', this.externalFilter)

                if(this.sendEvents) this.analyticsService.sendEvent('externalFilter', this.externalFilter)

                this._checkExternalLanguage(this.externalFilter.language).then(() => {
                    this.sectionList = ['map','list','calendar']

                    if(this.setView != null) {
                        let _split = this.setView.split(',')

                        if(_split.length == 1) {
                            this.currentSection = this.setView;
                            this.lockSection = true;
                        }
                        else {
                            this.currentSection = _split[0]
                            this.sectionList = _split;
                        }
                    }
    
                    let _filteredGroups:Array<string> = null;

                    if(this.externalFilter.groups != null && this.externalFilter.groups != '') {
                        _filteredGroups = this._externalFilterArrayOrSplit(this.externalFilter.groups);
                        this.filterData.groups = JSON.parse(JSON.stringify(_filteredGroups))
                    }

                    let _filteredTypes:Array<EFProductType> = null;

                    if(this.externalFilter.type != null && this.externalFilter.type != '') {
                        _filteredTypes = this._externalFilterArrayOrSplit(this.externalFilter.type);

                        this.filterData.type = this.mixTypes ? null : _filteredTypes[0] as any;

                        if(_filteredTypes.length == 1) {
                            this.lockFilterType = true;
                        }
                    }
    
                    if(this.externalFilter.category != null && this.externalFilter.category != '') {
                        if(!this.mixTypes && this.filterData.type == null) {
                            _filteredTypes = ['experience'];
                            this.filterData.type = 'experience';
                            this.lockFilterType = true;
                        }

                        this.filterData.category[this.filterData.type] = {}

                        let _filterCategories = this._externalFilterArrayOrSplit(this.externalFilter.category)

                        for(let _cCategory of _filterCategories) {
                            this.filterData.category[this.filterData.type][_cCategory] = true;
                        }
        
                        if(_filterCategories.length == 1) {
                            this.lockFilter = true;
                        }
                    }

                    if(this.externalFilter.tags != null && this.externalFilter.tags != '') {
                        if(!this.mixTypes && this.filterData.type == null) {
                            _filteredTypes = ['experience'];
                            this.filterData.type = 'experience';
                            this.lockFilterType = true;
                        }

                        this.filterData.tags = this._externalFilterArrayOrSplit(this.externalFilter.tags);
                    }

                    if(this.externalFilter.users != null && this.externalFilter.users != '') {
                        this.filterData.users = this._externalFilterArrayOrSplit(this.externalFilter.users)
                    }

                    if(this.externalFilter.ids != null && this.externalFilter.ids != '') {
                        this.lockFilterType = true;
                        this.lockFilter = true;
                        this.filterData.ids = this._externalFilterArrayOrSplit(this.externalFilter.ids)
                    }

                    if(this.externalFilter.past != null) {
                        this.lockPast = true;
                        this.filterData.past = {}

                        for(let _type of ['experience', 'event', 'package']) {
                            this.filterData.past[_type] = this.externalFilter.past
                        }
                    }
    
                    if(this.externalFilter.product != null && this.externalFilter.product != '') this.onShowProduct(this.externalFilter.product, true)

                    console.log('Filter status', {
                        filterData: this.filterData,
                        lockFilterType: this.lockFilterType,
                        lockFilter: this.lockFilter,
                        lockPast: this.lockPast
                    })

                    resolve({ types: _filteredTypes, groups: _filteredGroups });
                });
            }
        })
    }

    private _handleFilterFragment() {
        if(this.fragment != null) {
            if(this.fragment.view != null) this.currentSection = this.fragment.view;

            if(this.fragment.filter != null) {
                for(let i in this.fragment.filter) {
                    this.filterData[i] = this.fragment.filter[i]
                }
            }

            if(this.fragment.product) this.onShowProduct(this.fragment.product, true)
        }
    }

    private _generateFragment() {
        this.fragment = {
            view: this.currentSection,
            filter: this.filterData,
            product: this.modalProductTarget == null ? null : this.modalProductTarget.id
        }

        this.fragmentChange.emit(this.fragment) 
    }

    mapBounds:google.maps.LatLngBounds = null;

    private _mapBoundsTimeout = null;

    onMapBoundsChange(val:google.maps.LatLngBounds) {
        if(this._mapBoundsTimeout != null) {
            clearTimeout(this._mapBoundsTimeout)
        }

        this._mapBoundsTimeout = setTimeout(() => {
            this._mapBoundsTimeout = null;

            this.mapBounds = val;

            this.mapFilteredProductsData = []

            let _sortValue:{ [id:string]: Array<number|string> } = {}

            let _mapCenter = this.mapBounds.getCenter();
            let _now = new Date()

            for(let _product of this.filteredProductsData) {
                if(_product.geolocation != null) {
                    let _coordinates = new google.maps.LatLng(_product.geolocation.coordinates[0], _product.geolocation.coordinates[1])

                    if(this.mapBounds.contains(_coordinates)) {
                        this.mapFilteredProductsData.push(_product)

                        if(this.environmentService.environment.ExperienceFinderSort == 'alphabetical') {
                            _sortValue[_product.id] = [this.getTranslated(_product, 'title')]
                        }
                        else if(this.environmentService.environment.ExperienceFinderSort == 'shuffle') {
                            _sortValue[_product.id] = [Math.random()];
                        }
                        else {
                            _sortValue[_product.id] = [
                                _product.availability?.getFirstEndAfter(_now)?.getTime() || Infinity,
                                google.maps.geometry.spherical.computeDistanceBetween(_coordinates, _mapCenter)
                            ]
                        }
                    }
                }
            }

            this.mapFilteredProductsData.sort((a, b) => {
                let _aList = _sortValue[a.id]
                let _bList = _sortValue[b.id]

                for(let i = 0; i < _aList.length; i++) {
                    let _aVal = _aList[i];
                    let _bVal = _bList[i];

                    if(_aVal < _bVal) return -1;
                    else if(_aVal > _bVal) return 1;
                }

                return 0;
            })

        }, 250)
    }

    async onFilterDataChange() {
        await this._loadProducts()
        this.applyFilter();
    }

    @ViewChild('efMapComponent') efMapComponent:EfMapComponent;

    goToSection(section:string) {
        this.currentSection = section;
        this.applyFilter();
    }

    private _filterToEventData() {
        let _eventData:any = {};
        let _type = this.filterData.type;

        _eventData.type = _type

        let _categoryList = []

        if(this.filterData.category[_type] != null) {
            if(!this.filterData.allCategories) {
                let _allIn = true;

                for(let i in this.filterData.category[_type]) {
                    if(this.filterData.category[_type][i]) {
                        _categoryList.push(i)
                    }
                    else {
                        _allIn = false;
                    }
                }
    
                if(!_allIn) {
                    _eventData.category = _categoryList;
                }
            }
        }

        if(!this.filterData.allSubcategories) {
            if(this.filterData.subcategory[_type] != null) {
                let _subcategoryList = [];

                let _allIn = true;

                for(let i in this.filterData.subcategory[_type]) {
                    if(this.filterData.allCategories || _categoryList.indexOf(i) != -1) {
                        for(let j in this.filterData.subcategory[_type][i]) {
                            if(this.filterData.subcategory[_type][i][j]) {
                                _subcategoryList.push(j)
                            }
                            else {
                                _allIn = false;
                            }
                        }
                    }
                }

                if(!_allIn) {
                    _eventData.subcategory = _subcategoryList;
                }
            }
        }

        if(this.filterData.language[_type] != null) {
            let _languageList = []

            for(let i in this.filterData.language[_type]) {
                if(this.filterData.language[_type][i]) {
                    _languageList.push(i)
                }
            }

            if(_languageList.length != Object.keys(this.filterData.language[_type]).length) {
                _eventData.language = _languageList;
            }
        }

        if(this.filterData.groups != null && this.filterData.groups[_type] != null && this.filterData.groups[_type].length > 0) {
            _eventData.groups = this.filterData.groups[_type];
        }

        if(this.filterData.tags != null && this.filterData.tags.length > 0) {
            _eventData.tags = this.filterData.tags;
        }

        if(this.filterData.ids != null && this.filterData.ids.length > 0) {
            _eventData.ids = this.filterData.ids;
        }

        if(this.filterData.interval != null && (this.filterData.interval.from != null || this.filterData.interval.to != null)) {
            _eventData.interval = this.filterData.interval;
        }

        return _eventData;
    }

    private _applyFilterSendEventTimeout = null;

    applyFilter() {
        let _productsData = [];

        for(let i in this.productsData) {
            if(this.productsData[i] != null) {
                for(let _product of this.productsData[i]) {
                    _productsData.push(_product)
                }
            }
        }

        let _eventData = this._filterToEventData();

        clearTimeout(this._applyFilterSendEventTimeout) // questo delay è per evitare di mandare un sacco di eventi se l'utente smanetta con gli switch dei filtri
        this._applyFilterSendEventTimeout = setTimeout(() => {
            if(this.sendEvents) this.analyticsService.sendEvent('applyFilter', _eventData)
        }, 2500)

        this.filteredProductsData = this.efDataService.applyProductsFilter(_productsData, this.filterData, this.presetCategories)

        this.mapFilteredProductsData = null;

        setTimeout(() => {
            this.centerMap();
        }, 100)

        this._generateFragment();
    }

    centerMap() {
        if(this.efMapComponent != null) {
            this.efMapComponent.centerMap(true);
            if(this.mapBounds != null) this.onMapBoundsChange(this.mapBounds);
        }
    }

    modalProductPath:Array<string> = null;
    modalProductTarget:EFProduct = null;
    modalSupplierTarget:EFSupplier = null;
    modalPOITarget:EFPOI = null;

    isLoadingDetail = false;

    productsHighlight:Array<string> = []

    private async _checkLoadProduct(product:string, setType?:boolean) {
        if(/^musement:experience/.test(product)) {
            if(setType) {
                this.filterData.type = 'experience';
                await this.onFilterDataChange()
            }

            for(let _item of this.productsData.experience) {
                if(_item.id == product) {
                    return _item
                }
            }
        }
        else {
            this.isLoadingDetail = true;
            return await new Promise<EFProduct>((resolve, reject) => {
                this.efDataService.getProductDetail(product).subscribe((data) => {
                    this.isLoadingDetail = false;
                    resolve(data)

                    if(setType) {
                        this.filterData.type = data.type;
                        this.onFilterDataChange();
                    }

                }, () => {
                    this.isLoadingDetail = false;
                    reject()
                })
            })
        }
    }

    onShowProduct(product:string, setType?:boolean) {
        this.modalProductPath = product.split('/');

        let _productId = this.modalProductPath[this.modalProductPath.length - 1]

        this.productsHighlight = [_productId];

        this.modalProductTarget = null;
        this.modalSupplierTarget = null;
        this.modalPOITarget = null;

        this._checkLoadProduct(_productId, setType).then((data) => {
            this.modalProductTarget = data;
            if(this.sendEvents && data.analytics != null) this.analyticsService.sendEvent('showProduct', data.analytics)

            if(data.supplier != null) {
                this.efDataService.getSupplier(data.supplier).subscribe((data) => {
                    this.modalSupplierTarget = data;
                })
            }

            if(data.poi_id != null) {
                this.efDataService.getPOI(data.poi_id).subscribe((data) => {
                    this.modalPOITarget = data;
                })
            }

            this._generateFragment();
        })
    }

    modalProductBack() {
        if(this.modalProductPath.length == 1) {
            this.modalProductPath = null;
            this.modalProductTarget = null;

            this.productsHighlight = null;
        }
        else {
            this.modalProductPath.pop();
            this.onShowProduct(this.modalProductPath.join('/'))
        }

        this._generateFragment();
    }

    getModalProductBackLabel() {
        if(this.modalProductPath.length == 1) {
            return this.localizationService.translate('experience-finder.ef-main.nav-back-' + this.currentSection)
        }
        else {
            let _productId = this.modalProductPath[this.modalProductPath.length - 2]

            for(let i in this.productsData) {
                for(let _cProduct of this.productsData[i]) {
                    if(_cProduct.id == _productId) {
                        return this.localizationService.translate('experience-finder.ef-main.nav-back-' + (_cProduct.type), { title: _cProduct.title })
                    }
                }
            }
        }
    }

    getCurrentProductsData(mapFiltered?:boolean) {
        return mapFiltered ? this.mapFilteredProductsData : this.filteredProductsData;
    }

    getTranslated(product:EFProduct, prop:string) {
        if(product.translations != null && product.translations[this.localizationService.currentLanguage] != null && product.translations[this.localizationService.currentLanguage][prop] != null) {
            return product.translations[this.localizationService.currentLanguage][prop]
        }
        else return product[prop]
    }

    doCumulativeBooking() {
        let _filter = []
        
        for(let _item of this.filteredProductsData) {
            _filter.push(_item.element)
        }

        // event → experience~Event (per filtri type==event su getResourceData)
        // checkout URL → experience (book-experience)
        let _resource = this.efDataService.getResourceFromProductType(this.filterData.type);
        let _bookType = (this.dataService.getCleanResourceId(_resource) || this.filterData.type).toLowerCase();

        this.dataService.getResourceData(_resource, { filter: [{ field: 'id', operator: 'in', value: _filter }]}, null, null, 'public').subscribe((data) => {
            let _cumulative = []

            for(let _item of data) {
                if(_item.bookable) {
                    _cumulative.push(_item.id)
                }
            }


            if(_cumulative.length == 0) {
                this.pgModalService.alert(this.localizationService.translate('experience-finder.ef-main.cluster-empty-title'), this.localizationService.translate('experience-finder.ef-main.cluster-empty-body'))
            }
            else if(_cumulative.length == 1) {
                window.open(this.environmentService.getApplicationURL('Checkout') + '/book-' + _bookType + '/' + _cumulative[0])
            }
            else {
                window.open(this.environmentService.getApplicationURL('Checkout') + '/book-' + _bookType + '/cumulative[' + _cumulative.join(',') + ']')
            }
    
            this.filterComponent.isCumulativeBooking = false;
        })

    }
}
